"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidateMethods = exports.InitMethodes = void 0;
var Methodes = require("./AanvraagMethodes/Methodes");
function InitMethodes() {
    Methodes.InitMethods();
}
exports.InitMethodes = InitMethodes;
function ValidateMethods() {
    //if ((Methodes.$tableMethods.find('.tdProductsInError').length == 0) && (Methodes.$tableMethodsFavorites.find('.tdProductsInError').length == 0)) {
    if ((Methodes.$tableMethods.find('.tdProductsInError').length == 0) && (Methodes.$tableMethodsFavorites.find('.tdProductsInError').length == 0) && (Methodes.$tableMethodsMicro.find('.tdProductsInError').length == 0)) {
        return true;
    }
    else {
        $("#dialogMethods").dialog("open");
        return false;
    }
    // check allowed methods
}
exports.ValidateMethods = ValidateMethods;
